export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    headerAlign: 'center',
    field: 'brandNo',
    align: 'left',
    minWidth: 150,
    title: '品牌',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'orderNo',
    align: 'left',
    minWidth: 150,
    title: 'DMS订单号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'orderType',
    align: 'center',
    width: 120,
    title: '订单类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'sourceNo',
    align: 'center',
    width: 120,
    title: '售达方编码',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'sourceName',
    align: 'center',
    width: 120,
    title: '售达方名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'destNo',
    align: 'center',
    width: 120,
    title: '送达方编码',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'destName',
    align: 'center',
    width: 120,
    title: '送达方名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'destAddr',
    align: 'center',
    width: 120,
    title: '送货地址',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'destContactName',
    align: 'center',
    width: 120,
    title: '收货联系人',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'destContactPhone',
    align: 'center',
    width: 120,
    title: '收货联系人电话',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'destCity',
    align: 'center',
    width: 120,
    title: '送达城市',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'materialNo',
    align: 'center',
    width: 120,
    title: '物料编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'materialDesc',
    align: 'center',
    width: 200,
    title: '中文物料描述',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'orderUnit',
    align: 'center',
    width: 120,
    title: '订单单位',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'deliveryQty',
    align: 'center',
    width: 120,
    title: '交货数量',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'supplierBatch',
    align: 'center',
    width: 120,
    title: '批次',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'validityDateStr',
    align: 'center',
    width: 120,
    title: '有效期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'manufactoryName',
    align: 'center',
    width: 120,
    title: '生产商',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'hpNumber',
    align: 'center',
    width: 120,
    title: 'HP NO.',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'orderReceiveDateStr',
    align: 'center',
    width: 120,
    title: '订单接收日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'orderReceiveTimeStr',
    align: 'center',
    width: 120,
    title: '订单接收时间',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'shippingNo',
    align: 'center',
    width: 120,
    title: 'AX订单号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'itemGroupType',
    align: 'center',
    width: 120,
    title: '产品类别',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'tmsOrderNo',
    align: 'center',
    width: 160,
    title: 'TMS发货单号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'scalageDateStr',
    align: 'center',
    width: 120,
    title: '称重日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'scalageTimeStr',
    align: 'center',
    width: 120,
    title: '称重时间',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'shippingDateStr',
    align: 'center',
    width: 120,
    title: '出库日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'shippingTimeStr',
    align: 'center',
    width: 120,
    title: '出库时间',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'grossWeight',
    align: 'center',
    width: 120,
    title: '系统产品毛重',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'expectDeliveryTime',
    align: 'center',
    width: 120,
    title: '预计到达',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'actualDeliveryTime',
    align: 'center',
    width: 120,
    title: '实际到达',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'dalayDays',
    align: 'center',
    width: 120,
    title: '迟到天数',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'delayReasonCode',
    align: 'center',
    width: 120,
    title: '迟到原因代码',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'delayReasonDesc',
    align: 'center',
    width: 200,
    title: '迟到原因具体说明',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'actualDays',
    align: 'center',
    width: 120,
    title: '实际时长',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },

]
